'use client';

import { c as _c } from "react/compiler-runtime";
import cx from 'classix';
import { useSearchParams } from 'next/navigation';
import { useTranslations } from 'next-intl';
import { type ChangeEvent, useEffect, useState } from 'react';
import { useUnmount } from 'usehooks-ts';
import { type FiltersColumns, type ListingsFilterToggle } from '@/features/listing/types/listing-filters-types';
import Toggle from '@/ui/form-elements/toggle/toggle';
import styles from './listing-filter-toggle.module.scss';
interface ListingFilterToggleProps<Label> {
  filter: ListingsFilterToggle<Label>;
  setFilterLink: (link: {
    pathname: string;
    searchParams: URLSearchParams;
  }) => void;
  filterLink: {
    pathname: string;
    searchParams: URLSearchParams;
  };
  columns?: FiltersColumns;
}
export default function ListingFilterToggle(props) {
  const $ = _c(47);
  const {
    columns: t0,
    filter,
    filterLink,
    setFilterLink
  } = props;
  const columns = t0 === undefined ? "1" : t0;
  const translationsFilters = useTranslations("listing.filters");
  const searchParams = useSearchParams();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [selectedValues, setSelectedValues] = useState(t1);
  let t2;
  if ($[1] !== filter.defaultValue || $[2] !== filter.filterType || $[3] !== filter.name || $[4] !== filterLink.pathname || $[5] !== filterLink.searchParams || $[6] !== selectedValues || $[7] !== setFilterLink) {
    t2 = event => {
      const selectedValue = event.target.value;
      if (filter.filterType === "radio") {
        filterLink.searchParams.set(filter.name, event.target.value);
        if (event.target.value === filter.defaultValue) {
          filterLink.searchParams.delete(filter.name, event.target.value);
        }
        setSelectedValues([selectedValue]);
      } else {
        const updatedValues = selectedValues.includes(selectedValue) ? selectedValues.filter(value => value !== selectedValue) : [...selectedValues, selectedValue];
        if (updatedValues.length === 0) {
          filterLink.searchParams.delete(filter.name);
        } else {
          filterLink.searchParams.set(filter.name, updatedValues.join(","));
        }
        setSelectedValues(updatedValues);
      }
      setFilterLink({
        pathname: filterLink.pathname,
        searchParams: filterLink.searchParams
      });
    };
    $[1] = filter.defaultValue;
    $[2] = filter.filterType;
    $[3] = filter.name;
    $[4] = filterLink.pathname;
    $[5] = filterLink.searchParams;
    $[6] = selectedValues;
    $[7] = setFilterLink;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const creteNewSearchParams = t2;
  let t3;
  if ($[9] !== filter.defaultValue || $[10] !== filter.name || $[11] !== filterLink.searchParams) {
    t3 = () => {
      const defaultValue = filterLink.searchParams.get(filter.name) ?? filter.defaultValue;
      if (defaultValue) {
        setSelectedValues(defaultValue.split(","));
      } else {
        setSelectedValues([]);
      }
    };
    $[9] = filter.defaultValue;
    $[10] = filter.name;
    $[11] = filterLink.searchParams;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] !== filter.defaultValue || $[14] !== filter.name || $[15] !== filterLink || $[16] !== searchParams) {
    t4 = [filter.defaultValue, filter.name, filterLink, searchParams];
    $[13] = filter.defaultValue;
    $[14] = filter.name;
    $[15] = filterLink;
    $[16] = searchParams;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  useEffect(t3, t4);
  let t5;
  if ($[18] !== filterLink.pathname || $[19] !== searchParams || $[20] !== setFilterLink) {
    t5 = () => {
      setFilterLink({
        pathname: filterLink.pathname,
        searchParams: new URLSearchParams(searchParams.toString())
      });
    };
    $[18] = filterLink.pathname;
    $[19] = searchParams;
    $[20] = setFilterLink;
    $[21] = t5;
  } else {
    t5 = $[21];
  }
  useUnmount(t5);
  const t6 = styles[`listingFilterContainer__col${columns}`];
  const t7 = styles[`listingFilterContainer__${filter.optionsVariant ?? "standard"}`];
  let t8;
  if ($[22] !== t6 || $[23] !== t7) {
    t8 = cx(styles.listingFilterContainer, t6, t7);
    $[22] = t6;
    $[23] = t7;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  let t9;
  if ($[25] !== creteNewSearchParams || $[26] !== filter.filterType || $[27] !== filter.isOptionsTranslated || $[28] !== filter.name || $[29] !== filter.options || $[30] !== filter.optionsTranslatedKey || $[31] !== filter.optionsVariant || $[32] !== selectedValues || $[33] !== translationsFilters) {
    let t10;
    if ($[35] !== creteNewSearchParams || $[36] !== filter.filterType || $[37] !== filter.isOptionsTranslated || $[38] !== filter.name || $[39] !== filter.optionsTranslatedKey || $[40] !== filter.optionsVariant || $[41] !== selectedValues || $[42] !== translationsFilters) {
      t10 = option => {
        const Icon = option.icon;
        return <Toggle onChange={creteNewSearchParams} type={filter.filterType} id={option.value} name={`${filter.name}[]`} value={option.value} checked={selectedValues.includes(option.value)} variant={filter.optionsVariant} key={option.value}><div className={styles.listingFilterContainer_filter}>{Icon && <Icon size={18} />}<span>{filter.isOptionsTranslated && filter.optionsTranslatedKey ? translationsFilters(`${filter.optionsTranslatedKey}.${option.label}`) : option.label}</span></div></Toggle>;
      };
      $[35] = creteNewSearchParams;
      $[36] = filter.filterType;
      $[37] = filter.isOptionsTranslated;
      $[38] = filter.name;
      $[39] = filter.optionsTranslatedKey;
      $[40] = filter.optionsVariant;
      $[41] = selectedValues;
      $[42] = translationsFilters;
      $[43] = t10;
    } else {
      t10 = $[43];
    }
    t9 = filter.options.map(t10);
    $[25] = creteNewSearchParams;
    $[26] = filter.filterType;
    $[27] = filter.isOptionsTranslated;
    $[28] = filter.name;
    $[29] = filter.options;
    $[30] = filter.optionsTranslatedKey;
    $[31] = filter.optionsVariant;
    $[32] = selectedValues;
    $[33] = translationsFilters;
    $[34] = t9;
  } else {
    t9 = $[34];
  }
  let t10;
  if ($[44] !== t8 || $[45] !== t9) {
    t10 = <div className={t8}>{t9}</div>;
    $[44] = t8;
    $[45] = t9;
    $[46] = t10;
  } else {
    t10 = $[46];
  }
  return t10;
}